import React, { useState, useEffect } from 'react';
import { Box, styled, List, ListItem, ListItemText,Typography } from '@mui/material';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import { useNavigate, useLocation } from 'react-router-dom';
import InOutWard from '../Components/InOutWard';
import { selectPermissions } from '../redux/permissionsSlice';
import { useSelector } from 'react-redux';

const StyledTabs = styled(Tabs)({
  backgroundColor: '#e1e7ef',
  borderRadius: '10px',
  padding: '4px',
  '& .MuiTabs-indicator': {
    display: 'none',
  },
});

const StyledTab = styled(Tab)(({ theme }) => ({
  textTransform: 'none',
  fontWeight: 600,
  fontSize: '14px',
  minHeight: '36px',
  padding: '8px 16px',
  borderRadius: '5px',
  color: theme.palette.text.secondary,
  '&.Mui-selected': {
    color: '#fff',
    backgroundColor: '#635bff',
  },
}));
const StyledListItem = styled(ListItem)(({ theme }) => ({
  borderBottom: '1px solid #e1e7ef',
  padding: '10px 15px',
  cursor: 'pointer',
  '&:hover': {
    backgroundColor: '#5BB4D2'
  },
}));


const Inventory = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const permissions = useSelector(selectPermissions);
  
  const hasModulePermission = (moduleName) => {
    const modulePermission = permissions.find(permission => permission.ModuleName === moduleName);
    if (!modulePermission) return false;
    
    return Object.entries(modulePermission).some(([key, value]) => 
      ['AddRec', 'EditRec', 'DeleteRec', 'ViewRec'].includes(key) && value === "1"
    );
  }


  const allTabs = [
    { label: "Inward/OutWard", path: "/inventory/inward-outward", component: InOutWard ,moduleName: 'Inward/OutWard' },
  ];

  const tabs = allTabs.filter(tab => hasModulePermission(tab.moduleName));
  const [activeTab, setActiveTab] = useState(0);

  useEffect(() => {
    // If we're at exactly '/masters', redirect to the first available tab
    if (location.pathname === '/inventory' && tabs.length > 0) {
      navigate(tabs[0].path, { state: { permissions }, replace: true });
      setActiveTab(0);
      return;
    }

    // For other paths, find the matching tab
    const currentTabIndex = tabs.findIndex((tab) => tab.path === location.pathname);
    if (currentTabIndex !== -1) {
      setActiveTab(currentTabIndex);
    } else if (tabs.length > 0) {
      // If path not found but tabs exist, go to first tab
      navigate(tabs[0].path, { state: { permissions }, replace: true });
      setActiveTab(0);
    }
  }, [location.pathname, tabs.length, permissions]);

  const handleChange = (event, newValue) => {
    setActiveTab(newValue);
    navigate(tabs[newValue].path, { state: { permissions } });
  };

  // If no tabs are available due to permissions, show a message
  if (tabs.length === 0) {
    return (
      <Box sx={{ p: 3 }}>
      
        <Typography variant="h6">
          No master sections are available based on your permissions.
        </Typography>
      </Box>
    );
  }

  const ActiveComponent = tabs[activeTab]?.component || tabs[0]?.component;

  return (
    <Box sx={{ 
      width: '100%', 
      p: 2, 
      '& .MuiTabs-root': {
        padding: '7px 4px 0px 4px !important'
      } 
    }}>
      <Box sx={{ mb: 4 }}>
        <StyledTabs 
          value={activeTab} 
          onChange={handleChange} 
          sx={{ display: { xs: 'block', sm: 'none', md: 'block', lg: 'block' } }}
        >
          {tabs.map((tab, index) => (
            <StyledTab key={index} label={tab.label} />
          ))}
        </StyledTabs>

        <Box sx={{ display: { xs: 'block', sm: 'none' }, mt: 2 }}>
          <List>
            {tabs.map((tab, index) => (
              <StyledListItem 
                button 
                key={index} 
                onClick={() => {
                  navigate(tab.path, { state: { permissions } });
                }}
              >
                <ListItemText primary={tab.label} />
              </StyledListItem>
            ))}
          </List>
        </Box>
      </Box>

      <Box>
        {ActiveComponent && 
          <ActiveComponent permissions={permissions} />
        }
      </Box>
    </Box>
  );
};

export default Inventory;